import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export const useResizeObserver = ({
  ref,
  callback,
  dep,
}: {
  ref: React.RefObject<any>;
  callback(entry: ResizeObserverEntry): void;
  dep?: any[];
}) => {
  React.useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    const ro = new ResizeObserver((entries, observer) => {
      for (const entry of entries) {
        callback(entry);
      }
    });

    ro.observe(ref.current);

    return () => {
      ref.current && ro.unobserve(ref.current);
    };
  }, dep ?? []);
};
